<ng-container *transloco="let t">
<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center">{{ t('portal.tasks.attachedDocuments') }}</h5>
  <button
    type="button"
    class="btn-close"
    (click)="activeModal.dismiss()"
    aria-label="Close"
  ></button>
</div>

<div class="modal-body">
  <table class="table">
    <thead>
      <tr>
        <th class="min-w-200px">{{ t('portal.tasks.fileName') }}</th>
        <th class="min-w-200px">{{ t('portal.tasks.note') }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (document of task.linkedDocuments; track document.documentGuid) {
        <tr>
          <td class="min-w-200px">
            <span class="text-gray-800 fw-bold">{{ document.fileName }}</span>
          </td>
          <td class="min-w-200px">
            <span class="text-gray-800 fw-bold">{{
              document.borrowerNote === null
                ? t('portal.tasks.noNoteFromBorrower')
                : document.borrowerNote
            }}</span>
          </td>
          <td><span class="text-gray-800 fw-bold"></span></td>
          <td>
            @if (task.templateDocumentUrl) {
              <a
                [title]="t('portal.tasks.view')"
                class="align-text-bottom"
                (click)="goToFileLink(document.documentUrl)"
              >
                <i class="far fa-eye"></i>
              </a>
            }

            <a
              [title]="t('portal.tasks.download')"
              class="mx-2 align-text-bottom"
              (click)="downloadLink(document.documentUrl, document.fileName)"
            >
              <i class="fas fa-download"></i>
            </a>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
</ng-container>
